import { useCallback } from 'react'

import { useNavigate } from 'react-router-dom'

import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import { createSpotify, createTikTok, createAds } from 'src/Router/routes'

import { CrossSellPlatform } from './helpers'

const createRouteByPlatform: Record<CrossSellPlatform, string> = {
  [CampaignPlatformTypeEnum.SPOTIFY]: createSpotify,
  [CampaignPlatformTypeEnum.TIKTOK]: createTikTok,
  [CampaignPlatformTypeEnum.META]: createAds,
}

interface UseCrossSell {
  onCreateCampaign: (platform: CrossSellPlatform) => void
}

export const useCrossSell = (): UseCrossSell => {
  const navigate = useNavigate()

  const onCreateCampaign = useCallback(
    (platform: CrossSellPlatform): void => {
      navigate(createRouteByPlatform[platform])
    },
    [navigate],
  )

  return { onCreateCampaign }
}
